export const GET_BANK_UPLOADING = "GET_BANK_UPLOADING";
export const SET_BANK_UPLOADING = "SET_BANK_UPLOADING";
export const GET_BANK_UPLOADING_ID = "GET_BANK_UPLOADING_ID";
export const SET_BANK_UPLOADING_ID = "SET_BANK_UPLOADING_ID";

export const UPDATE_BANK_UPLOADING = "UPDATE_BANK_UPLOADING";
export const DELETE_BANK_UPLOADING = "DELETE_BANK_UPLOADING";

export const SET_STATUS_LOADER = "SET_STATUS_LOADER";
